// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../uploads/Mayor-Logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 64px); /* Adjust height to account for the AppBar */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Ensure the logo path is correct */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover; /* Cover the entire screen */
  background-color: rgba(6, 4, 15, 0.1); /* Dim the background slightly */
  background-blend-mode: multiply; /* Blend the logo with the dim background */
}

.upload-card {
  width: 900px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  text-align: center;
  background-color: rgba(70, 47, 126, 0.9); /* Semi-transparent white background */
  border: 2px solid #345172; /* Dark Blue */
}

.dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #002855; /* Dark Blue */
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  background-color: #FFFFFF;
  transition: border-color 0.3s ease;
  cursor: pointer;
}

.dropzone:hover {
  border-color: #FFC72C; /* Yellow */
}

.file-input {
  display: none; /* Hide the file input */
}
`, "",{"version":3,"sources":["webpack://./src/components/UploadForm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B,EAAE,4CAA4C;EACxE,yDAAkD,EAAE,oCAAoC;EACxF,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB,EAAE,4BAA4B;EACpD,qCAAqC,EAAE,gCAAgC;EACvE,+BAA+B,EAAE,2CAA2C;AAC9E;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC,EAAE,sCAAsC;EAChF,yBAAyB,EAAE,cAAc;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B,EAAE,cAAc;EAC1C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,qBAAqB,EAAE,WAAW;AACpC;;AAEA;EACE,aAAa,EAAE,wBAAwB;AACzC","sourcesContent":[".upload-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: calc(100vh - 64px); /* Adjust height to account for the AppBar */\n  background-image: url('../uploads/Mayor-Logo.png'); /* Ensure the logo path is correct */\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover; /* Cover the entire screen */\n  background-color: rgba(6, 4, 15, 0.1); /* Dim the background slightly */\n  background-blend-mode: multiply; /* Blend the logo with the dim background */\n}\n\n.upload-card {\n  width: 900px;\n  padding: 20px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  text-align: center;\n  background-color: rgba(70, 47, 126, 0.9); /* Semi-transparent white background */\n  border: 2px solid #345172; /* Dark Blue */\n}\n\n.dropzone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border: 2px dashed #002855; /* Dark Blue */\n  border-radius: 10px;\n  padding: 20px;\n  text-align: center;\n  background-color: #FFFFFF;\n  transition: border-color 0.3s ease;\n  cursor: pointer;\n}\n\n.dropzone:hover {\n  border-color: #FFC72C; /* Yellow */\n}\n\n.file-input {\n  display: none; /* Hide the file input */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
